export default __webpack_public_path__ + "static/media/nick.b157785a.jpg";